import { z } from 'zod'

/** Represents the enum public.device_inventory_status_type_ */
enum DeviceInventoryStatusType {
  SOLD = 'SOLD',
  LEASE = 'LEASE',
  READY_FOR_SALE = 'READY_FOR_SALE',
  TESTING = 'TESTING',
  IN_STORAGE = 'IN_STORAGE',
  DAMAGED = 'DAMAGED',
  UNBUILT = 'UNBUILT',
  UNKNOWN = 'UNKNOWN',
  LOST = 'LOST',
  NONE = 'NONE',
}

export default DeviceInventoryStatusType

/** Zod schema for device_inventory_status_type_ */
export const deviceInventoryStatusType = z.enum([
  'SOLD',
  'LEASE',
  'READY_FOR_SALE',
  'TESTING',
  'IN_STORAGE',
  'DAMAGED',
  'UNBUILT',
  'UNKNOWN',
  'LOST',
  'NONE',
])
